import type { RelatedEntity } from '@/lib/api/types.crm';

/** relatedType → detail route. Mirrors the RelatedEntity enum exactly. */
const MAP: Record<RelatedEntity, (id: string) => string> = {
  LEAD: (id) => `/crm/leads/${id}`,
  CONTACT: (id) => `/crm/contacts/${id}`,
  COMPANY: (id) => `/crm/companies/${id}`,
  DEAL: (id) => `/crm/deals/${id}`,
  PROJECT: (id) => `/projects/${id}`,
  TASK: (id) => `/tasks/${id}`,
  ASSET: (id) => `/assets/${id}`,
  PURCHASE_REQUEST: (id) => `/procurement/purchase-requests/${id}`,
  PURCHASE_ORDER: (id) => `/procurement/purchase-orders/${id}`,
  EMPLOYEE: (id) => `/hrms/employees/${id}`,
  VENDOR: (id) => `/procurement/vendors/${id}`,
};

/**
 * Path to the record a polymorphic link points at (notifications, calendar
 * deadlines, related-record links). Null when there's nothing to link to.
 */
export function recordPath(
  relatedType: RelatedEntity | null | undefined,
  id: string | null | undefined,
): string | null {
  return relatedType && id ? MAP[relatedType]?.(id) ?? null : null;
}
